export default {"src":"/_next/static/media/image_title.bfa75799.svg","height":100,"width":98,"blurWidth":0,"blurHeight":0};